"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEqualOrAfterTime = exports.isEqualOrBeforeTime = exports.isAfterTime = exports.isBeforeTime = exports.isNotEqualTime = exports.isEqualTime = exports.hasNoneOfUsers = exports.hasAnyOfUsers = exports.hasAllOfUsers = exports.isExactlyUser = exports.isNotObjectFieldEmpty = exports.isObjectFieldEmpty = exports.fileTypeIs = exports.fileNameContains = exports.isNotLink = exports.getRawLink = exports.isLink = exports.isSignatureHasValue = exports.notContainsList = exports.isNotListExact = exports.isListExact = exports.containsList = exports.isNotEmptyList = exports.isExactly = exports.isEmptyList = exports.hasNoneOf = exports.hasAnyOf = exports.hasAllOf = exports.yesNoIsEqualTo = exports.isNoneOf = exports.isAnyOf = exports.isZero = exports.isGreatThanZero = exports.isLessThan = exports.isEqualOrLessThan = exports.isGreaterThan = exports.isEqualOrGreaterThan = exports.isEqualOrGreaterThanAndNotEmpty = exports.isEqualOrLessThanAndNotEmpty = exports.isGreaterThanAndNotEmpty = exports.isLessThanAndNotEmpty = exports.isNotEqualTo = exports.isEqualTo = exports.notContains = exports.contains = exports.isNotEmpty = exports.isEmpty = exports.isNot = exports.invert = exports.is = void 0;
exports.isOnOrAfter = exports.isOnOrBefore = exports.isAfter = exports.isBefore = exports.isNotDate = exports.isDate = exports.uniqueList = exports.noopGenerator = exports.joinList = exports.forListSomeOrEmpty = exports.forListSome = exports.forListEvery = exports.flattenList = exports.stubTrueComparisons = exports.isNotEmptyColor = exports.isEmptyColor = exports.notContainsColor = exports.containsColor = exports.notIsColor = exports.isColor = exports.clipboardColorToSelf = exports.colorToString = exports.colorValueToString = exports.colorToHex = exports.parseCmykColor = exports.parseRgbColor = exports.parseHexColor = exports.parseColors = exports.parseColor = exports.isValidHexColor = exports.isNotListMultiple = exports.isListMultiple = exports.compareMomentTimes = void 0;
const types_1 = require("@smartsuite/types");
const date_fns_1 = require("date-fns");
const intersection_1 = __importDefault(require("lodash-es/intersection"));
const sortBy_1 = __importDefault(require("lodash-es/sortBy"));
const flatten_1 = __importDefault(require("lodash-es/flatten"));
const moment_timezone_1 = __importDefault(require("moment-timezone"));
const react_fast_compare_1 = __importDefault(require("react-fast-compare"));
const color_1 = __importDefault(require("color"));
const number_1 = require("../helpers/number");
const filter_1 = require("../utils/filter");
const fns_1 = require("../utils/fns");
const is = (filterValue = "") => {
    const lower = toLocaleLowerCaseSafety(filterValue);
    return (fieldValue) => toLocaleLowerCaseSafety(fieldValue) === lower;
};
exports.is = is;
const invert = (generator) => (filterValue) => {
    const predicate = generator(filterValue);
    return (fieldValue, field, userPreferences) => !predicate(fieldValue, field, userPreferences);
};
exports.invert = invert;
exports.isNot = (0, exports.invert)(exports.is);
const toLocaleLowerCaseSafety = (value) => {
    return typeof (value === null || value === void 0 ? void 0 : value.toLocaleLowerCase) === "function"
        ? value.toLocaleLowerCase()
        : undefined;
};
const isEmpty = (_filterValue) => {
    return (fieldValue) => {
        return (fieldValue === null ||
            fieldValue === undefined ||
            (typeof fieldValue === "string" && fieldValue.trim() === ""));
    };
};
exports.isEmpty = isEmpty;
exports.isNotEmpty = (0, exports.invert)(exports.isEmpty);
const contains = (filterValue) => {
    var _a;
    const lower = (_a = toLocaleLowerCaseSafety(filterValue)) !== null && _a !== void 0 ? _a : "";
    return (fieldValue) => { var _a; return !!((_a = toLocaleLowerCaseSafety(fieldValue)) === null || _a === void 0 ? void 0 : _a.includes(lower)); };
};
exports.contains = contains;
exports.notContains = (0, exports.invert)(exports.contains);
const isEqualTo = (filterValue) => {
    return (fieldValue) => fieldValue === filterValue;
};
exports.isEqualTo = isEqualTo;
exports.isNotEqualTo = (0, exports.invert)(exports.isEqualTo);
const isLessThanAndNotEmpty = (filterValue) => {
    const isLessThanPredicate = (0, exports.isLessThan)(filterValue);
    return (fieldValue, field) => fieldValue !== null && isLessThanPredicate(fieldValue, field);
};
exports.isLessThanAndNotEmpty = isLessThanAndNotEmpty;
const isGreaterThanAndNotEmpty = (filterValue) => {
    const isGreaterThanPredicate = (0, exports.isGreaterThan)(filterValue);
    return (fieldValue, field) => fieldValue !== null && isGreaterThanPredicate(fieldValue, field);
};
exports.isGreaterThanAndNotEmpty = isGreaterThanAndNotEmpty;
const isEqualOrLessThanAndNotEmpty = (filterValue) => {
    const isEqualOrLessThanPredicate = (0, exports.isEqualOrLessThan)(filterValue);
    return (fieldValue, field) => fieldValue !== null && isEqualOrLessThanPredicate(fieldValue, field);
};
exports.isEqualOrLessThanAndNotEmpty = isEqualOrLessThanAndNotEmpty;
const isEqualOrGreaterThanAndNotEmpty = (filterValue) => {
    const isEqualOrGreaterThanPredicate = (0, exports.isEqualOrGreaterThan)(filterValue);
    return (fieldValue, field) => fieldValue !== null && isEqualOrGreaterThanPredicate(fieldValue, field);
};
exports.isEqualOrGreaterThanAndNotEmpty = isEqualOrGreaterThanAndNotEmpty;
const isEqualOrGreaterThan = (filterValue) => {
    const isEqualToPredicate = (0, exports.isEqualTo)(filterValue);
    const isGreaterThanPredicate = (0, exports.isGreaterThan)(filterValue);
    return (fieldValue, field) => isEqualToPredicate(fieldValue, field) ||
        isGreaterThanPredicate(fieldValue, field);
};
exports.isEqualOrGreaterThan = isEqualOrGreaterThan;
const isGreaterThan = (filterValue) => {
    return (fieldValue) => Number(fieldValue) > Number(filterValue);
};
exports.isGreaterThan = isGreaterThan;
const isEqualOrLessThan = (filterValue) => {
    const isEqualToPredicate = (0, exports.isEqualTo)(filterValue);
    const isLessThanPredicate = (0, exports.isLessThan)(filterValue);
    return (fieldValue, field) => isEqualToPredicate(fieldValue, field) ||
        isLessThanPredicate(fieldValue, field);
};
exports.isEqualOrLessThan = isEqualOrLessThan;
const isLessThan = (filterValue) => {
    return (fieldValue) => Number(fieldValue) < Number(filterValue);
};
exports.isLessThan = isLessThan;
const isGreatThanZero = (_filterValue) => {
    return (fieldValue) => {
        return Number(fieldValue) > 0;
    };
};
exports.isGreatThanZero = isGreatThanZero;
const isZero = (_filterValue) => {
    return (fieldValue) => {
        return fieldValue === 0;
    };
};
exports.isZero = isZero;
const isAnyOf = (filterValue) => {
    return (fieldValue) => { var _a; return (_a = filterValue === null || filterValue === void 0 ? void 0 : filterValue.includes(fieldValue)) !== null && _a !== void 0 ? _a : false; };
};
exports.isAnyOf = isAnyOf;
exports.isNoneOf = (0, exports.invert)(exports.isAnyOf);
const yesNoIsEqualTo = (filterValue) => {
    return (fieldValue) => filterValue
        ? fieldValue === filterValue
        : [undefined, false, null].includes(fieldValue);
};
exports.yesNoIsEqualTo = yesNoIsEqualTo;
const hasAllOf = (filterValue) => {
    return (fieldValue) => {
        return (!!filterValue.length &&
            (0, intersection_1.default)(fieldValue, filterValue).length === filterValue.length);
    };
};
exports.hasAllOf = hasAllOf;
const hasAnyOf = (filterValue) => {
    return (fieldValue) => (0, intersection_1.default)(fieldValue, filterValue).length > 0;
};
exports.hasAnyOf = hasAnyOf;
const hasNoneOf = (filterValue) => {
    return (fieldValue) => (0, intersection_1.default)(fieldValue, filterValue).length === 0;
};
exports.hasNoneOf = hasNoneOf;
const isEmptyList = () => {
    return (fieldValue) => !!fieldValue && Array.isArray(fieldValue) && fieldValue.length === 0;
};
exports.isEmptyList = isEmptyList;
const isExactly = (filterValue) => {
    const sorted = (0, sortBy_1.default)(filterValue);
    return (fieldValue) => (0, react_fast_compare_1.default)((0, sortBy_1.default)(fieldValue), sorted);
};
exports.isExactly = isExactly;
exports.isNotEmptyList = (0, exports.invert)(exports.isEmptyList);
const containsList = (filterValues) => {
    const filterValuesLowerCase = filterValues.map((value) => value.toLowerCase());
    return (fieldValue) => {
        return filterValuesLowerCase.every((part) => {
            return fieldValue.some((elem) => {
                const value = elem.toLowerCase();
                return (part && value === part) || value.includes(part);
            });
        });
    };
};
exports.containsList = containsList;
const isListExact = (filterValue) => {
    const sortedFilterValues = filterValue === null || filterValue === void 0 ? void 0 : filterValue.map((a) => a.toLocaleLowerCase()).sort();
    return (fieldValue) => {
        const sortedFieldValues = fieldValue === null || fieldValue === void 0 ? void 0 : fieldValue.map((a) => a.toLocaleLowerCase()).sort();
        return ((sortedFilterValues === null || sortedFilterValues === void 0 ? void 0 : sortedFilterValues.length) > 0 &&
            (sortedFieldValues === null || sortedFieldValues === void 0 ? void 0 : sortedFieldValues.length) > 0 &&
            sortedFieldValues.join(",") === sortedFilterValues.join(","));
    };
};
exports.isListExact = isListExact;
exports.isNotListExact = (0, exports.invert)(exports.isListExact);
exports.notContainsList = (0, exports.invert)(exports.containsList);
const isSignatureHasValue = (value) => {
    var _a;
    return !!(value === null || value === void 0 ? void 0 : value.text) || !!((_a = value === null || value === void 0 ? void 0 : value.drawing) === null || _a === void 0 ? void 0 : _a.length) || !!(value === null || value === void 0 ? void 0 : value.image_base64);
};
exports.isSignatureHasValue = isSignatureHasValue;
const isLink = (filterValue) => {
    const filterLinks = filterValue.map(exports.getRawLink).sort();
    return (fieldValue) => {
        const fieldLinks = fieldValue.map(exports.getRawLink).sort();
        return ((fieldLinks === null || fieldLinks === void 0 ? void 0 : fieldLinks.length) > 0 &&
            (filterLinks === null || filterLinks === void 0 ? void 0 : filterLinks.length) > 0 &&
            filterLinks.join(",") === fieldLinks.join(","));
    };
};
exports.isLink = isLink;
const getRawLink = (link) => {
    let raw = link.replace(/^(?:https?:\/\/)?(?:www\.)?/i, ""); // Remove https://www. from comparison
    raw = raw.replace(/\/$/, ""); // Remove / at the end for comparison
    return raw;
};
exports.getRawLink = getRawLink;
exports.isNotLink = (0, exports.invert)(exports.isLink);
exports.fileNameContains = exports.contains;
const fileTypeIs = (filterValue) => {
    return (fieldValue) => fieldValue.includes(filterValue);
};
exports.fileTypeIs = fileTypeIs;
const isObjectFieldEmpty = (_filterValue) => {
    return (fieldValue) => {
        return (fieldValue === null ||
            fieldValue === undefined ||
            fieldValue === "" ||
            fieldValue === 0);
    };
};
exports.isObjectFieldEmpty = isObjectFieldEmpty;
exports.isNotObjectFieldEmpty = (0, exports.invert)(exports.isObjectFieldEmpty);
const replaceVariablesInFilterValues = (filterValues, currentMemberId) => {
    const preparedFilterValue = cleanCurrentMemberFromValuesIfUndefined(filterValues, currentMemberId).map((value) => {
        var _a;
        return value === types_1.currentMemberChoiceValue
            ? (_a = currentMemberId === null || currentMemberId === void 0 ? void 0 : currentMemberId.toString()) !== null && _a !== void 0 ? _a : ""
            : value;
    });
    return [...new Set(preparedFilterValue)];
};
const isExactlyUser = (filterValues, currentMemberId) => {
    const predicate = (0, exports.isExactly)(replaceVariablesInFilterValues(filterValues, currentMemberId));
    return (fieldValues, field) => predicate(fieldValues, field);
};
exports.isExactlyUser = isExactlyUser;
const hasAllOfUsers = (filterValues, currentMemberId) => {
    const predicate = (0, exports.hasAllOf)(replaceVariablesInFilterValues(filterValues, currentMemberId));
    return (fieldValues, field) => predicate(fieldValues, field);
};
exports.hasAllOfUsers = hasAllOfUsers;
const hasAnyOfUsers = (filterValues, currentMemberId) => {
    const predicate = (0, exports.hasAnyOf)(replaceVariablesInFilterValues(filterValues, currentMemberId));
    return (fieldValues, field) => predicate(fieldValues, field);
};
exports.hasAnyOfUsers = hasAnyOfUsers;
const hasNoneOfUsers = (filterValues, currentMemberId) => {
    const predicate = (0, exports.hasNoneOf)(replaceVariablesInFilterValues(filterValues, currentMemberId));
    return (fieldValues, field) => predicate(fieldValues, field);
};
exports.hasNoneOfUsers = hasNoneOfUsers;
const cleanCurrentMemberFromValuesIfUndefined = (filterValues, currentMemberId) => {
    var _a;
    return ((_a = filterValues === null || filterValues === void 0 ? void 0 : filterValues.filter((value) => value !== types_1.currentMemberChoiceValue || !!currentMemberId)) !== null && _a !== void 0 ? _a : []);
};
const isEqualTime = (filterValue) => {
    return (fieldValue) => (0, exports.compareMomentTimes)(fieldValue, filterValue).isSame;
};
exports.isEqualTime = isEqualTime;
exports.isNotEqualTime = (0, exports.invert)(exports.isEqualTime);
const isBeforeTime = (filterValue) => {
    return (fieldValue) => (0, exports.compareMomentTimes)(fieldValue, filterValue).isBefore;
};
exports.isBeforeTime = isBeforeTime;
const isAfterTime = (filterValue) => {
    return (fieldValue) => (0, exports.compareMomentTimes)(fieldValue, filterValue).isAfter;
};
exports.isAfterTime = isAfterTime;
const isEqualOrBeforeTime = (filterValue) => {
    const isEqualToPredicate = (0, exports.isEqualTime)(filterValue);
    const isBeforeThanPredicate = (0, exports.isBeforeTime)(filterValue);
    return (fieldValue, field) => isEqualToPredicate(fieldValue, field) ||
        isBeforeThanPredicate(fieldValue, field);
};
exports.isEqualOrBeforeTime = isEqualOrBeforeTime;
const isEqualOrAfterTime = (filterValue) => {
    const isEqualToPredicate = (0, exports.isEqualTime)(filterValue);
    const isAfterThanPredicate = (0, exports.isAfterTime)(filterValue);
    return (fieldValue, field) => isEqualToPredicate(fieldValue, field) ||
        isAfterThanPredicate(fieldValue, field);
};
exports.isEqualOrAfterTime = isEqualOrAfterTime;
const compareMomentTimes = (timeOne, timeTwo) => {
    const formattedTimeOne = moment_timezone_1.default.utc(timeOne, "HH:mm").toDate();
    const formattedTimeTwo = moment_timezone_1.default.utc(timeTwo, "HH:mm").toDate();
    return {
        isAfter: (0, date_fns_1.isAfter)(formattedTimeOne, formattedTimeTwo),
        isBefore: (0, date_fns_1.isBefore)(formattedTimeOne, formattedTimeTwo),
        isSame: (0, date_fns_1.isEqual)(formattedTimeOne, formattedTimeTwo),
    };
};
exports.compareMomentTimes = compareMomentTimes;
const isListMultiple = (filterValue) => {
    return (fieldValue) => !!fieldValue &&
        !!filterValue &&
        filterValue.some((filterElement) => fieldValue.includes(filterElement));
};
exports.isListMultiple = isListMultiple;
exports.isNotListMultiple = (0, exports.invert)(exports.isListMultiple);
const HEX_REGEX = /^#[0-9A-Fa-f]{6}$/;
const NOT_RGB_REGEX = /((.)+( )?,){3}/g; // rgb has only 3 attributes (separated by only 2 commas)
const isValidHexColor = (color) => {
    return HEX_REGEX.test(color);
};
exports.isValidHexColor = isValidHexColor;
const parseColor = (value) => {
    var _a, _b;
    if (!value) {
        return null;
    }
    const normalizedValue = value.trim().toLocaleLowerCase();
    return ((_b = (_a = (0, exports.parseHexColor)(normalizedValue)) !== null && _a !== void 0 ? _a : (0, exports.parseRgbColor)(normalizedValue)) !== null && _b !== void 0 ? _b : (0, exports.parseCmykColor)(normalizedValue));
};
exports.parseColor = parseColor;
const parseColors = (value) => {
    return value
        .split("|")
        .map((part) => (0, exports.parseColor)(part))
        .filter((c) => !!c);
};
exports.parseColors = parseColors;
const parseHexColor = (value) => {
    var _a;
    return (_a = createColor(value)) !== null && _a !== void 0 ? _a : createColor(`#${value}`);
};
exports.parseHexColor = parseHexColor;
const parseRgbColor = (value) => {
    var _a;
    const normalizedValue = (value || "").replace(/:/g, ",");
    const isNotRgb = normalizedValue.match(NOT_RGB_REGEX);
    if (isNotRgb) {
        return null;
    }
    return ((_a = createColor(normalizedValue, "rgb")) !== null && _a !== void 0 ? _a : createColor(`rgb(${normalizedValue})`, "rgb"));
};
exports.parseRgbColor = parseRgbColor;
const parseCmykColor = (value) => {
    var _a;
    const matches = (_a = value.match(/\d+(\.\d+)?(%)?/g)) !== null && _a !== void 0 ? _a : [];
    const numbers = matches.map(parseFloat);
    return numbers.length === 4 ? createColor(numbers, "cmyk") : null;
};
exports.parseCmykColor = parseCmykColor;
const colorToHex = (color) => {
    return color.hex();
};
exports.colorToHex = colorToHex;
const colorToRgb = (color) => {
    const [r, g, b] = color.rgb().array();
    return `rgb(${r}, ${g}, ${b})`;
};
const colorToCmyk = (color) => {
    return color
        .cmyk()
        .array()
        .map((n) => String((0, number_1.round)(n)))
        .map((s) => `${s}%`)
        .join(", ");
};
const colorValueToString = (value, displayFormat) => {
    const color = (0, exports.parseColor)(value.value);
    if (!color) {
        return "";
    }
    const colorValue = (0, exports.colorToString)(color, displayFormat);
    return value.name ? `${value.name} (${colorValue})` : colorValue;
};
exports.colorValueToString = colorValueToString;
const colorToString = (color, displayFormat) => {
    switch (displayFormat) {
        case "rgb":
            return colorToRgb(color);
        case "cmyk":
            return colorToCmyk(color);
        default:
            return (0, exports.colorToHex)(color);
    }
};
exports.colorToString = colorToString;
function clipboardColorToSelf(clipboardValue, srcField, targetField) {
    var _a;
    const values = (_a = clipboardValue.rawValue) !== null && _a !== void 0 ? _a : [];
    if (targetField.params.entries_allowed === "multiple") {
        return values;
    }
    else {
        return values.length > 0 ? [values[0]] : [];
    }
}
exports.clipboardColorToSelf = clipboardColorToSelf;
const createColor = (value, mode) => {
    try {
        return (0, color_1.default)(value, mode);
    }
    catch (err) {
        return null;
    }
};
const isColor = (filterValue) => {
    const filterParts = (filterValue !== null && filterValue !== void 0 ? filterValue : "").split("|");
    const filterColors = filterParts
        .map((v) => (0, exports.parseColor)(v))
        .filter((c) => !!c)
        .map(exports.colorToHex)
        .sort();
    return (fieldValue) => {
        const fieldColors = fieldValue
            .map((val) => (0, exports.parseColor)(val.value))
            .filter((c) => !!c)
            .map(exports.colorToHex)
            .sort();
        return ((fieldColors === null || fieldColors === void 0 ? void 0 : fieldColors.length) > 0 &&
            (filterColors === null || filterColors === void 0 ? void 0 : filterColors.length) > 0 &&
            filterColors.join(",") === fieldColors.join(","));
    };
};
exports.isColor = isColor;
exports.notIsColor = (0, exports.invert)(exports.isColor);
const containsColor = (filterValue) => {
    const lower = filterValue === null || filterValue === void 0 ? void 0 : filterValue.toLocaleLowerCase();
    const filterParts = lower.split("|");
    return (fieldValue, field) => {
        const displayFormat = field.params
            .display_format;
        if (!fieldValue.length) {
            return false;
        }
        return containAllColors(filterParts, fieldValue, displayFormat);
    };
};
exports.containsColor = containsColor;
const containAllColors = (filterParts, fieldValue, displayFormat) => {
    return filterParts.every((part) => {
        const partColor = (0, exports.parseColor)(part);
        return fieldValue.some((elem) => {
            if (!!partColor && elem.value === partColor.hex()) {
                return true;
            }
            const parsedColor = (0, exports.parseColor)(elem.value);
            if (parsedColor === null) {
                return false;
            }
            const displayValue = (0, exports.colorToString)(parsedColor, displayFormat);
            return displayValue.toLowerCase().includes(part);
        });
    });
};
exports.notContainsColor = (0, exports.invert)(exports.containsColor);
const isEmptyColor = () => {
    return (fieldValue) => !(fieldValue === null || fieldValue === void 0 ? void 0 : fieldValue.length);
};
exports.isEmptyColor = isEmptyColor;
exports.isNotEmptyColor = (0, exports.invert)(exports.isEmptyColor);
/**
 * This is a stub object for BaseFieldType's this.comparisons property.
 *
 * It can be used as a fallback if we cannot retrieve original "this.comparisons" for some reason.
 * The example can be a calculated field that cannot access its target field, therefore unable to
 * get predicates from there.
 */
exports.stubTrueComparisons = types_1.Comparisons.reduce((result, key) => {
    const stubComparison = () => true;
    const stubComparisonGenerator = () => stubComparison;
    result[key] = stubComparisonGenerator;
    return result;
}, {});
const flattenList = (generator) => (filterValue) => {
    const predicate = generator(filterValue);
    return (fieldValue, field) => predicate((0, flatten_1.default)(Array.isArray(fieldValue) ? fieldValue : [fieldValue]), field);
};
exports.flattenList = flattenList;
/**
 * Returns a new predicate generator that applies the generator parameter to every element in a list.
 * Gives a match if EVERY element of the list is a match.
 */
const forListEvery = (generator) => (filterValue) => {
    const predicate = generator(filterValue);
    return (fieldValue, field) => {
        const asArray = Array.isArray(fieldValue) ? fieldValue : [fieldValue];
        return asArray.every((value) => predicate(value, field));
    };
};
exports.forListEvery = forListEvery;
/**
 * Returns a new predicate generator that applies the generator parameter to every element in a list.
 * Gives a match if ANY element of the list is a match.
 */
const forListSome = (generator) => (filterValue) => {
    const predicate = generator(filterValue);
    return (fieldValue, field) => {
        const asArray = Array.isArray(fieldValue) ? fieldValue : [fieldValue];
        return asArray.some((value) => predicate(value, field));
    };
};
exports.forListSome = forListSome;
const forListSomeOrEmpty = (generator) => (filterValue) => {
    const predicate = generator(filterValue);
    return (fieldValue, field) => {
        const asArray = Array.isArray(fieldValue) ? fieldValue : [fieldValue];
        if (asArray.length === 0) {
            return true;
        }
        return asArray.some((value) => predicate(value, field));
    };
};
exports.forListSomeOrEmpty = forListSomeOrEmpty;
const joinList = (generator) => (filterValue) => {
    const predicate = generator(filterValue);
    return (fieldValue, field) => {
        const asArray = Array.isArray(fieldValue) ? fieldValue : [fieldValue];
        return predicate(asArray.join(" "), field);
    };
};
exports.joinList = joinList;
const noopGenerator = () => () => false;
exports.noopGenerator = noopGenerator;
const uniqueList = (generator) => (filterValue) => {
    const predicate = generator(filterValue);
    return (fieldValue, field) => {
        const precessedValue = Array.isArray(fieldValue)
            ? fieldValue.filter(filter_1.filterUniqueValues)
            : fieldValue;
        return predicate(precessedValue, field);
    };
};
exports.uniqueList = uniqueList;
const isDate = (filterValue) => {
    return (fieldValue) => {
        return (!!fieldValue &&
            !!filterValue.lower &&
            !!filterValue.upper &&
            (0, fns_1.isBetween)(fieldValue, filterValue.lower, filterValue.upper, filterValue.bounds));
    };
};
exports.isDate = isDate;
exports.isNotDate = (0, exports.invert)(exports.isDate);
const isBefore = (filterValue) => {
    const startOf = (0, date_fns_1.startOfDay)(filterValue);
    return (fieldValue) => fieldValue && (0, date_fns_1.isBefore)(fieldValue, startOf);
};
exports.isBefore = isBefore;
const isAfter = (filterValue) => {
    const endOf = (0, date_fns_1.endOfDay)(filterValue);
    return (fieldValue) => fieldValue && (0, date_fns_1.isAfter)(fieldValue, endOf);
};
exports.isAfter = isAfter;
const isOnOrBefore = (filterValue) => {
    return (fieldValue) => fieldValue &&
        ((0, date_fns_1.isSameDay)(fieldValue, filterValue) ||
            (0, date_fns_1.isBefore)(fieldValue, filterValue));
};
exports.isOnOrBefore = isOnOrBefore;
const isOnOrAfter = (filterValue) => {
    return (fieldValue) => fieldValue &&
        ((0, date_fns_1.isSameDay)(fieldValue, filterValue) || (0, date_fns_1.isAfter)(fieldValue, filterValue));
};
exports.isOnOrAfter = isOnOrAfter;
